export enum AlertVariants {
  Default = 'DEFAULT',
  Info = 'INFO',
  Positive = 'POSITIVE',
  Negative = 'NEGATIVE',
  Warning = 'WARNING',
  Notice = 'NOTICE',
  Guide = 'GUIDE',
}
